import * as moment from 'moment';

import { Component, OnInit, Renderer2 } from '@angular/core';

import { EventsService } from './shared/services/utils/events.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { AppState } from './store/index';

import * as RouterActions from './store/router/router.actions';

// import * as Flickity from 'flickity';
import { isEmptyObject, triggerOnResizeDelay } from './shared/lib/helpers/utils';
import { TranslateService } from '@ngx-translate/core';
import { SEOService } from './shared/services/b2b/seo.service';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SalesforceService } from './shared/services/utils/salesforce.service';
import { SoledadOpinionsService } from './shared/services/b2b/opinions.service';
import { Subscriber } from './shared/lib/helpers/subscriber';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>`
})
export class AppComponent extends Subscriber implements OnInit {
    openModal: boolean = false;
    private readonly baseBodyClasses: string[] = Array.from(document.body.classList);

    constructor(
        private eventsService: EventsService,
        private router: Router,
        private translate: TranslateService,
        private store: Store<AppState>,
        private activatedRoute: ActivatedRoute,
        private seoService: SEOService,
        private salesforceService: SalesforceService,
        private opinionsService: SoledadOpinionsService
    ) {
        super();
        translate.setDefaultLang('es');
        moment.locale('es');
    }

    ngOnInit() {
        // Token opinions
        this.getOpinionsToken();
        this.salesforceService.init();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.updateBodyClass();
                this.syncLayout();
                this.salesforceService.trackPageView(event.urlAfterRedirects);
            }
        });

        // Monitorize event and redirect to login route
        this.eventsService.on('exitApp').subscribe(() => {
            // this.router.navigate(['login']);
            this.store.dispatch(
                new RouterActions.Go({
                    path: ['login']
                })
            );
        });

        // Monitorize event and redirect to dashboard route
        this.eventsService.on('enterApp').subscribe(() => {
            this.store.dispatch(
                new RouterActions.Go({
                    path: ['dashboard/main']
                })
            );
        });

        this.eventsService.on('enterAppAnonymous').subscribe(() => {
            this.store.dispatch(
                new RouterActions.Go({
                    path: ['dashboard/products']
                })
            );
        });

        this.subscribeSEO();
    }

    private updateBodyClass() {
        const currentRoute = this.getChildRoute(this.activatedRoute);

        // Restaurar las clases base del body antes de aplicar las de la ruta actual.
        document.body.className = this.baseBodyClasses.join(' ');

        // Obtener la clase específica para la ruta actual
        const bodyClass = this.getRouteData(currentRoute, 'bodyClass') || '';
        // const bodyClass = this.getRouteData(currentRoute, 'bodyClass') || 'min-h-screen';

        // Aplicar la clase al body si está definida
        if (bodyClass) {
            document.body.classList.add(bodyClass);
        }
    }

    private syncLayout() {
        window.requestAnimationFrame(() => {
            window.dispatchEvent(new Event('resize'));
            triggerOnResizeDelay();
        });
    }

    private getChildRoute(route: ActivatedRoute): ActivatedRoute {
        let child = route.firstChild;
        while (child.firstChild) {
            child = child.firstChild;
        }
        return child || route;
    }

    private getRouteData(route: ActivatedRoute, key: string): any {
        let data = route.snapshot.data[key];
        while (route.firstChild) {
            route = route.firstChild;
            data = { ...data, ...route.snapshot.data[key] };
        }
        return data;
    }

    subscribeSEO(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map((route) => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                filter((route) => route.outlet === 'primary'),
                mergeMap((route) => route.data)
            )
            .subscribe((event) => {
                if (!isEmptyObject(event)) {
                    this.seoService.updateTitle(event['title']);
                    // We can updating Description tag dynamically with title: event['title'] + event['description']
                    this.seoService.updateDescription(event['description']);
                }
            });
    }

    getOpinionsToken() {
        this.addSubscription(
            this.opinionsService.getToken().subscribe(
                (data) => {
                    let token = data.token;
                    localStorage.setItem('tokenOpinions', token);
                },
                (error) => console.log('couldnt get Soledad API token')
            )
        );
    }
}
